import { Component, Input } from "@angular/core";

import { PrisberegnerResultatDetaljelinjeViewModel, PrisberegnerTrappeGroupId } from "../model/prisberegner.view-model";
import { DecimalPipe } from "@angular/common";

const MAX_TAPPE_VISIBLE = 3;

export interface MoreGroupRow {
    isMoreGroup: true;
    groupKey: string;
    hiddenCount: number;
    isExpanded: boolean;
}

export type SpecifikationDisplayRow = PrisberegnerResultatDetaljelinjeViewModel | MoreGroupRow;

function isMoreGroupRow(row: SpecifikationDisplayRow): row is MoreGroupRow {
    return (row as MoreGroupRow).isMoreGroup === true;
}

@Component({
    selector: "prisberegner-specifikation",
    templateUrl: "./prisberegner-specifikation.component.html",
    styleUrls: ["./prisberegner-specifikation.component.scss"],
    imports: [DecimalPipe]
})
export class PrisberegnerSpecifikationComponent {
    @Input()
    public linjer: PrisberegnerResultatDetaljelinjeViewModel[] = [];

    public expandedGroups: Record<string, boolean> = {};

    public isMoreGroupRow = isMoreGroupRow;

    public getDisplayRows(): SpecifikationDisplayRow[] {
        const rows: SpecifikationDisplayRow[] = [];
        const list = this.linjer || [];
        let i = 0;
        const groupCount: Partial<Record<PrisberegnerTrappeGroupId, number>> = {};

        while (i < list.length) {
            const linje = list[i];
            if (linje.trappeGroupId) {
                const gid = linje.trappeGroupId;
                const group: PrisberegnerResultatDetaljelinjeViewModel[] = [];
                while (i < list.length && (list[i] as PrisberegnerResultatDetaljelinjeViewModel).trappeGroupId === gid) {
                    group.push(list[i] as PrisberegnerResultatDetaljelinjeViewModel);
                    i++;
                }
                const count = (groupCount[gid] = (groupCount[gid] ?? 0) + 1);
                const groupKey = `${gid}-${count}`;

                if (group.length <= MAX_TAPPE_VISIBLE) {
                    rows.push(...group);
                } else {
                    const isExpanded = !!this.expandedGroups[groupKey];
                    const moreRow: MoreGroupRow = {
                        isMoreGroup: true,
                        groupKey,
                        hiddenCount: group.length - MAX_TAPPE_VISIBLE,
                        isExpanded
                    };
                    if (isExpanded) {
                        rows.push(...group);
                        rows.push(moreRow);
                    } else {
                        rows.push(...group.slice(0, MAX_TAPPE_VISIBLE));
                        rows.push(moreRow);
                    }
                }
                continue;
            }
            rows.push(linje);
            i++;
        }
        return rows;
    }

    public toggleMore(groupKey: string): void {
        this.expandedGroups = {
            ...this.expandedGroups,
            [groupKey]: !this.expandedGroups[groupKey]
        };
    }
}
